import EFeatureFlags from 'enums/featureFlags'
import useFeatureFlagValue from 'hooks/useFeatureFlagValue'
import Head from 'next/head'
import NewApplicationForm from '../../components/pages/ApplyApplicationPage'
import NewApplicationFormV3 from '../../components/pages/ApplyApplicationPage/application-form-v3.index'

const ApplyApplicationPage = () => {
  const { isEnabled: isEnableApplicationFormV2 } = useFeatureFlagValue(EFeatureFlags.WEBSITE_APPLICATION_FORM_V2)
  return (
    <>
      <Head>
        <title>{'HomeRoom Apply'}</title>
        <link rel="icon" href="/favicon_black.png" />
      </Head>
      {isEnableApplicationFormV2 === false && isEnableApplicationFormV2 !== undefined && <NewApplicationFormV3 />}
      {isEnableApplicationFormV2 && <NewApplicationForm />}
    </>
  )
}

export default ApplyApplicationPage
